import { ChangeEvent, TextareaHTMLAttributes, forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

import { InputTextArea } from './styles';

export interface IFormInputTextAreaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  dataCy?: string;
  resize?: boolean;
}

export const FormInputTextArea = forwardRef<
  HTMLTextAreaElement,
  IFormInputTextAreaProps
>(
  // eslint-disable-next-line no-restricted-syntax
  function FormInputTextArea(
    {
      name,
      dataCy = 'input-text-area',
      autoComplete = 'off',
      resize = true,
      onChange,
      ...inputProps
    }: IFormInputTextAreaProps,
    ref
  ) {
    const { register } = useFormContext();

    const { onChange: registerOnChange, ...registerProps } = register(name);

    const handleChange = async (event: ChangeEvent<HTMLTextAreaElement>) => {
      onChange?.(event);
      await registerOnChange(event);
    };

    return (
      <InputTextArea
        // @ts-expect-error: 'ref' is specified more than once, so this usage will be overwritten.
        ref={ref}
        {...inputProps}
        {...registerProps}
        name={name}
        data-cy={dataCy}
        autoComplete={autoComplete}
        $resize={resize}
        onChange={(e) => {
          void handleChange(e);
        }}
      />
    );
  }
);
